import { animated, useSpring } from "@react-spring/web";
import React from "react";

import { cn } from "@/utils/cn";

interface ProgressBarProps {
  /** Number between 0 and 1 to represent the percentage complete. */
  progress: number;
  /** Height of the progress bar. */
  size?: "sm" | "md";
  /** If true, use a linear gradient for the filled portion */
  isGradient?: boolean;
}

/** A horizontal meter filled to the given percentage. */
const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  size = "md",
  isGradient = false,
}) => {
  const progressStyle = useSpring({
    width: `${progress * 100}%`,
    from: { width: "0%" },
  });

  return (
    <div
      className={cn(
        "h-2.5 w-full overflow-hidden rounded-lg bg-gray-300 dark:bg-gray-800",
        {
          "h-2.5": size === "md",
          "h-[6px]": size === "sm",
        },
      )}
    >
      <animated.div
        className={cn("h-full", {
          "bg-primary-500": !isGradient,
          "bg-linear-to-r from-primary-200 to-primary-500 dark:from-primary-800 dark:to-primary-400":
            isGradient,
        })}
        style={progressStyle}
      />
    </div>
  );
};

export { ProgressBar as default, ProgressBar };
